import { render, staticRenderFns } from "./FreeofCostPurchase.vue?vue&type=template&id=1e4af740&"
import script from "./FreeofCostPurchase.vue?vue&type=script&lang=js&"
export * from "./FreeofCostPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports